$(document).ready(function() {
    // Quick add client resource
    $(document).on('click', '.clients-momentum-sections-resource-component .add-client-resource-js', function() {
        const $btn = $(this);

        // Remove feedback from any previously clicked button
        $('.add-client-resource-js.added').removeClass('added');

        // Add visual feedback immediately
        $btn.addClass('added');
        const $icon = $btn.find('i.fa-plus');
        $icon.removeClass('fa-plus').addClass('fa-check');

        // Send Ajax POST
        $.post('/components/clients/momentum_sections/resource/add_client_resource', {
            hs_contact_id: $btn.attr('hs_contact_id'),
            momentum_resource_id: $btn.attr('resource_id'),
        }).done(function(data) {
            // Reload resource lists
            $('.clients-meetings-resource-list-component').each(function() {
                reloadComponent($(this));
            });
            window.reloadClientTaskBinComponents();
            // keep the checkmark for a moment
            setTimeout(function() {
                $btn.removeClass('added');
                $icon.removeClass('fa-check').addClass('fa-plus');
            }, 1200);
        }).fail(function() {
            // Show a warning for failure and revert UI
            $btn.removeClass('added');
            $icon.removeClass('fa-check').addClass('fa-plus');
            alert("Could not add resource.");
        });
    });
});
